import { render, staticRenderFns } from "./exchange-list-skeleton.vue?vue&type=template&id=69a28f14&scoped=true&lang=pug&"
import script from "./exchange-list-skeleton.vue?vue&type=script&lang=js&"
export * from "./exchange-list-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./exchange-list-skeleton.vue?vue&type=style&index=0&id=69a28f14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a28f14",
  null
  
)

export default component.exports